import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ApiCustom from "../../utils/ApiCustom";

const approveSchema = Yup.object().shape({
  criteriaId: Yup.string().trim().required("Tiêu chí không được để trống"),
});

const fieldLabels = {
  criteriaId: "Chọn tiêu chí",
};

const PartnerCriteriaModal = ({ isOpen, id, onClose }) => {
  const [formData, setFormData] = useState({
    criteriaId: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [criteria, setCriteria] = useState([]);

  useEffect(() => {
    getDataCriteria();
  }, []);

  const getDataCriteria = async () => {
    ApiCustom.get("/criteria-show-public")
      .then((res) => {
        const dataRes = res.data.data?.data;
        const criteriaData = dataRes.filter((x) => x.type === null);
        setCriteria(criteriaData);
      })
      .catch((err) => console.log(err));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await approveSchema.validate(formData, { abortEarly: false });
      await ApiCustom.put(`/company-change-point/${id}`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      onClose(true);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
      } else {
        toast.error("Đã xảy ra lỗi! Vui lòng thử lại.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold ">Đánh giá hội viên</h2>
            <button
              onClick={() => onClose(false)}
              className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
            >
              X
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="gap-10 mb-5">
              <div className="w-full">
                <label className="block text-sm font-medium mb-1">
                  {fieldLabels.criteriaId}
                  <i className="text-red-600"> *</i>
                </label>
                <select
                  name={formData.criteriaId}
                  value={formData.criteriaId}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      criteriaId: e.target.value,
                    });
                    setErrors({
                      ...errors,
                      criteriaId: "",
                    });
                  }}
                  className={`w-full p-2 border rounded-md ${
                    errors.criteriaId ? "border-red-500" : "border-gray-300"
                  } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                >
                  <option value="">Chọn tiêu chí</option>
                  {criteria?.map((item, idx) => (
                    <option key={idx} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {errors.criteriaId && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.criteriaId}
                  </p>
                )}
              </div>

              <div className="my-4">
                <label className="block text-sm font-medium mb-1">Lý do</label>
                <textarea
                  name="reason"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      reason: e.target.value,
                    });
                  }}
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  rows={5}
                ></textarea>
              </div>
            </div>

            {/* Footer - Action Buttons */}
            <div className="flex justify-end space-x-4 pt-4 border-t">
              <button
                type="button"
                onClick={() => onClose(false)}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className={`px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                  isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {isLoading ? "Đang xử lý..." : "Xác nhận"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PartnerCriteriaModal;
